module.exports = __webpack_public_path__ + "icon_person_add-5c56ef10b9e99e77a44d89041f4b77b5.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/icon_person_add.svg
// module id = 265
// module chunks = 86